import { Injectable } from '@angular/core';
import { MatStepperIntl } from '@angular/material/stepper';

@Injectable()
export class MatStepperIntlDe extends MatStepperIntl {
  override optionalLabel = 'Nur bei RLT';
}
